namespace GeniuzPOS.PosShift {
    export interface LookupPostranhdrefundtaxRow {
        Id?: number;
        DocNo?: string;
        DocDate?: string;
        DocTime?: string;
        RefDocNo?: string;
        PosId?: string;
        CashierId?: string;
        MbId?: string;
        SalesmanId?: string;
        SalesVatType?: string;
        Factor?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        AllItemCharge?: number;
        BillDiscount?: number;
        NetSales?: number;
        BillCharge?: number;
        DocAmt?: number;
        Vat?: number;
        RoundAdjust?: number;
        NetSalesNormal?: number;
        NetSalesPromo?: number;
        NetSalesExVat?: number;
        NetSalesNonVat?: number;
        VatOfNetSales?: number;
        VatOfCharge?: number;
        ReceiveCash?: number;
        ReceiveCreditCd?: number;
        ReceiveDebitCd?: number;
        ReceiveCoupon?: number;
        ReceiveCashCd?: number;
        ReceivePoint?: number;
        ReceiveOthers?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ShopId?: string;
        RefundFg?: number;
        PostFg?: number;
        ErpAutoGenStamp?: string;
        DpType?: number;
    }

    export namespace LookupPostranhdrefundtaxRow {
        export const idProperty = 'DocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.LookupPostranhdrefundtax';
        export const lookupKey = 'LookupPostranhdrefundtaxRow';

        export function getLookup(): Q.Lookup<LookupPostranhdrefundtaxRow> {
            return Q.getLookup<LookupPostranhdrefundtaxRow>('LookupPostranhdrefundtaxRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            DocDate = "DocDate",
            DocTime = "DocTime",
            RefDocNo = "RefDocNo",
            PosId = "PosId",
            CashierId = "CashierId",
            MbId = "MbId",
            SalesmanId = "SalesmanId",
            SalesVatType = "SalesVatType",
            Factor = "Factor",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            AllItemCharge = "AllItemCharge",
            BillDiscount = "BillDiscount",
            NetSales = "NetSales",
            BillCharge = "BillCharge",
            DocAmt = "DocAmt",
            Vat = "Vat",
            RoundAdjust = "RoundAdjust",
            NetSalesNormal = "NetSalesNormal",
            NetSalesPromo = "NetSalesPromo",
            NetSalesExVat = "NetSalesExVat",
            NetSalesNonVat = "NetSalesNonVat",
            VatOfNetSales = "VatOfNetSales",
            VatOfCharge = "VatOfCharge",
            ReceiveCash = "ReceiveCash",
            ReceiveCreditCd = "ReceiveCreditCd",
            ReceiveDebitCd = "ReceiveDebitCd",
            ReceiveCoupon = "ReceiveCoupon",
            ReceiveCashCd = "ReceiveCashCd",
            ReceivePoint = "ReceivePoint",
            ReceiveOthers = "ReceiveOthers",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ShopId = "ShopId",
            RefundFg = "RefundFg",
            PostFg = "PostFg",
            ErpAutoGenStamp = "ErpAutoGenStamp",
            DpType = "DpType"
        }
    }
}
